import {
  createProductTranslator,
  kit321Catalog,
  type ProductMessageKey,
  type ProductMessageValues,
} from "@xunbei/i18n";

export type Kit321MessageKey = ProductMessageKey<typeof kit321Catalog>;
export type Kit321Locale = "en" | "zh" | "zh-CN";

const translators = {
  en: createProductTranslator(kit321Catalog, "en"),
  "zh-CN": createProductTranslator(kit321Catalog, "zh-CN"),
} as const;

export function uiMessage(
  key: Kit321MessageKey,
  locale: Kit321Locale,
  values?: ProductMessageValues,
): string {
  return translators[locale === "en" ? "en" : "zh-CN"].t(key, values);
}
